
    import { defineComponent, type PropType } from 'vue'
    import { useI18n } from 'vue-i18n-composable'

    import type { Ad } from '@/common/models/data/dashboard/ads'
    import { useGtag } from '@/common/composables/libs/gtag'

    export default defineComponent({
        props: {
            ad: {
                type: Object as PropType<Ad | undefined>,
                default: undefined,
            }
        },
        setup (props) {
            const gtag = useGtag()
            const i18n = useI18n()

            const onAdClick = (): void => {
                gtag.event(i18n.t('analytics.ads.click-empty').toString(), {
                    event_category: i18n.t('ads.ad')
                })
            }

            const onEmptyPlaceClick = (): void => {
                if (!props.ad) {
                    return
                }

                gtag.event(i18n.t('analytics.ads.click').toString(), {
                    event_category: i18n.t('ads.ad'),
                    event_label: props.ad.title
                })
            }

            return {
                onAdClick,
                onEmptyPlaceClick
            }
        }
    })
